import { breakpoints } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const HideMobileCol = styled.col `
  ${breakpoints.xs} {
    display: none;
  }
`;
export const ShowMobileCol = styled.col `
  ${breakpoints.sm} {
    display: none;
  }
`;
